require('./rightsAccessView.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { bindActionCreators } = require('redux');
const { withRouter } = require('react-router-dom');
const { getFinalTitle, formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

// @utilities
const { GDPR_ACCESS_ID } = require('constants/operationTypes');
const { getLastNChars } = require('utilities/stringHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @actions
const rightsActions = require('actions/rightsProfile');

// @ constants
const { ACCESS } = require('constants/index');

class RightsAccessView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            account: this.props.immAccounts.getIn(['byId', this.props.immAccounts.getIn(['byOrder', 0]), 'accountId'])
        }

        this.setNextStep = this.setNextStep.bind(this);
        this.setLastStep = this.setLastStep.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.cancel = this.cancel.bind(this);
        this.buildLastStepRightsAccess = this.buildLastStepRightsAccess.bind(this);
        this.buildPayRightsAccess = this.buildPayRightsAccess.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    componentWillUnmount() {
        this.props.rightsActions.resetRightsProfile();
    }

    // cancel form
    cancel() {
        this.props.history.push('/myprofile/rights');
    }

    // nextStep
    setNextStep() {
        this.props.rightsActions.nextStepAccess();
    }

    // lasttStep
    setLastStep() {
        this.props.rightsActions.lastStepAccess();
    }

    // change account (if user need to pay)
    handleAccountChange(accountId){
        this.setState({account: accountId});
    }

    // finsh form and post reports
    onFinish() {
        this.props.rightsActions.postRights(ACCESS);
    }

    // show info about profile´s data
    buildInfoRightsAccess() {
      const { immProfileFields } = this.props;
      const injectedStrings = [PersonalDataHelper.getEmail(immProfileFields)];
      return(
          <div>
              <div className="rights-access-view__header-wizard">
                  <h3 className="rights-access-view__title-step">
                      <FormattedText value="rightsAccess-titleStep" />
                  </h3>
                  <p className="rights-access-view__sub-title-step">
                      <FormattedText value="rightsAccess-subTitleSteps" injectedStrings={injectedStrings} />
                  </p>
              </div>
              <hr className="rights-access-view__separator-wizard"/>
              <div className="rights-access-view__list-wizard">
                  <FormattedText value="rightsAccess-descriptionFirstStep" />
              </div>
          </div>
      )
    }

    // show payment method (not neccesary yet)
    buildPayRightsAccess() {
        const { immAccounts } = this.props;
        const { account } = this.state;
        const accountsIndexes = immAccounts.get('byOrder').toJS();

        return(
            <div>
                <div className="rights-access-view__header-wizard">
                    <h3 className="rights-access-view__title-step">
                        <FormattedText value="rightsAccess-titlePayStep" />
                    </h3>
                    <p className="rights-access-view__sub-title-step">
                        <FormattedText value="rightsAccess-subTitlePaySteps" />
                    </p>
                </div>
                <hr className="rights-access-view__separator-wizard"/>
                <div className="row rights-access-view__drop-accounts">
                    <div className="col-xs-12 col-md-5">
                        <DropdownAccounts
                            immAccounts={immAccounts.get('byId')}
                            accountsIndexes={accountsIndexes}
                            currentAccountId={account}
                            onAccountChange={this.handleAccountChange}
                        />
                    </div>
                </div>
            </div>
        )
    }

    // last step with otp and report´s information
    buildLastStepRightsAccess() {
        const { immRightsProfile, immProfileFields } = this.props;
        const { account } = this.state;
        const isFree = immRightsProfile.get('nextFreeAccess');
        const ibanFormatted = getLastNChars((this.props.immAccounts.getIn(['byId', this.state.account, 'iban'])));
        const injectedStrings = [PersonalDataHelper.getEmail(immProfileFields)];
        const aliasAccount = this.props.immAccounts.getIn(['byId', account, 'alias']);

        return(
            <div>
                <div className="rights-access-view__header-wizard">
                    <h3 className="rights-access-view__title-step">
                        <FormattedText value="rightsAccess-titleStep" />
                    </h3>
                    <p className="rights-access-view__sub-title-step">
                        <FormattedText value="rightsAccess-subTitleSteps" injectedStrings={injectedStrings} />
                    </p>
                </div>
                <div className="rights-access-view__cost">
                    {isFree &&
                        <FormattedText value="rightsAccess-free" />
                    }
                    {!isFree &&
                        <div>
                            <p>
                                <FormattedText value="rightsAccess-pay" />
                            </p>
                            <p className="rights-access-view__title-account-charge">
                                <FormattedText value="rightsAccess-accountSelected" />
                            </p>
                            <div>
                                <span className="rights-access-view__account-charge-information">{aliasAccount}{ibanFormatted}</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }

    buildWizardSuccess() {
        const { immProfileFields } = this.props;
        const oldEmailUser = PersonalDataHelper.getEmail(immProfileFields);
        const goBackButtonLabel = formatText('rightsAccess-goBackButton').toUpperCase();
        const goBackButton = {
            label: goBackButtonLabel,
            url: '/myprofile/edit'
        }

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8 rights-access-view__container-wizard">
                    <div className="row">
                        <WizardSuccess
                            successMessage={formatText('rightsAccess-successStepTitle')}
                            mainButton={goBackButton}
                            successSubMessage={
                                <FormattedText
                                    value="rightsAccess-descriptionSuccess"
                                    injectedStrings={[oldEmailUser]}
                                />
                            }
                        >
                        </WizardSuccess>
                    </div>
                </div>
            </div>
        );
    }
    getError(error) {
        if (error == 409)
            return 'rightsAccess-errorMessageWizardRequestInProgress'
        if (error == 477)
            return 'rightsAccess-errorMessageWizardNoEmail'
        return 'rightsAccess-errorMessageWizard'

    }

    buildWizardError(error) {
        const errorTitle = formatText('rightsAccess-errorTitleWizard');
        const errorMessage = formatText(this.getError(error));
        const goBackButtonLabel = formatText('rightsAccess-goBackButton').toUpperCase();
        const goBackButton = {
            label: goBackButtonLabel,
            url: '/myprofile/edit'
        }

        return (
            <div className="row grid-view--content-position-negative">
                <div className="col-xs-12 col-md-8 rights-access-view__container-wizard">
                    <div className="row">
                        <WizardError
                            errorMessage={errorTitle}
                            errorSubMessage={errorMessage}
                            mainButton={goBackButton}
                        />
                    </div>
                </div>
            </div>
        );
    }

    // buildThreeSteps(actions) {
    //     const { immRightsProfile, immProfileFields } = this.props;
    //     const stepsAccess = immRightsProfile.get('stepsAccessPay');
    //     const immFinalButton = 'rightsAccess-finalButtonOTP';
    //     const infoStep = this.buildInfoRightsAccess();
    //     const paymentStep = this.buildPayRightsAccess();
    //     const lastStep = this.buildLastStepRightsAccess();
    //     const hasEmail = !!PersonalDataHelper.getEmail(immProfileFields)

    //     return(
    //         <Wizard
    //             stepsAmount={stepsAccess.size}
    //             visibleStep={immRightsProfile.get('visibleStepAccess')}
    //             showPreLeaveModal={true}
    //             actions={actions}
    //             onConfirmLeave={() => { }}
    //             immSteps={stepsAccess}
    //         >
    //             <WizardStep
    //                 position="first"
    //                 key={1}
    //                 cancelButton={true}
    //                 nextButtonDisabled={!hasEmail}
    //                 tooltipNextButton={true}
    //                 tooltipNextButtonContent="consents-nextButtonStep"
    //             >
    //                 {infoStep}
    //             </WizardStep>
    //             <WizardStep
    //                 position="middle"
    //                 key={2}
    //                 cancelButton={true}
    //                 nextButtonDisabled={false}
    //                 tooltipNextButton={true}
    //                 tooltipNextButtonContent="consents-nextButtonStep"
    //             >
    //                 {paymentStep}
    //             </WizardStep>
    //             <WizardStep
    //                 position="last"
    //                 key={3}
    //                 cancelButton={true}
    //                 previousButton={true}
    //                 finishButton={true}
    //                 immFinalButton={immFinalButton}
    //             >
    //                 {lastStep}
    //                 <SignaturePattern
    //                     operationType={GDPR_ACCESS_ID}
    //                     operationParams={{}}
    //                 />
    //             </WizardStep>
    //         </Wizard>
    //     );
    // }

    buildTwoSteps(actions) {
        const { immRightsProfile, immProfileFields } = this.props;
        const stepsAccess = immRightsProfile.get('stepsAccess');
        const immFinalButton = 'rightsAccess-finalButtonOTP';
        const infoStep = this.buildInfoRightsAccess();
        const lastStep = this.buildLastStepRightsAccess();
        const hasEmail = !!PersonalDataHelper.getEmail(immProfileFields)

        return(
            <Wizard
                stepsAmount={stepsAccess.size}
                visibleStep={immRightsProfile.get('visibleStepAccess')}
                showPreLeaveModal={true}
                actions={actions}
                onConfirmLeave={() => { }}
                immSteps={stepsAccess}
            >
                <WizardStep
                    position="first"
                    key={1}
                    cancelButton={true}
                    nextButtonDisabled={!hasEmail}
                    tooltipNextButton={true}
                    tooltipNextButtonContent="consents-doesntHaveEmail"
                >
                    {infoStep}
                </WizardStep>
                <WizardStep
                    position="last"
                    key={2}
                    cancelButton={true}
                    previousButton={true}
                    finishButton={true}
                    immFinalButton={immFinalButton}
                >
                    {lastStep}
                    <SignaturePattern
                        operationType={GDPR_ACCESS_ID}
                        operationParams={{}}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    buildWizardForm() {
        // const { immRightsProfile } = this.props;
        // const isFree = immRightsProfile.get('nextFreeAccess');
        // const typeWizard = isFree ? this.buildTwoSteps(actions) : this.buildThreeSteps(actions);
        const actions = {
            finish: this.onFinish,
            setWillCancel: (() => { }),
            cancel: this.cancel,
            setVisibleStep: this.setLastStep,
            validateStep: this.setNextStep
        };

        const typeWizard = this.buildTwoSteps(actions)

        return(
            <div className="row grid-view--content-position-negative rights-selector-view">
                <div className="col-xs-12 col-md-8 rights-access-view__container-wizard">
                    <div className="row">
                        {typeWizard}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { immRightsProfile } = this.props;
        const accessSuccess = immRightsProfile.get('successAccess');
        const accessError = immRightsProfile.get('errorAccess');
        let wizard;

        if (!accessSuccess && !accessError) {
            wizard = this.buildWizardForm();
        } else if (accessSuccess && !accessError) {
            wizard = this.buildWizardSuccess();
        } else if (!accessSuccess && accessError) {
            wizard = this.buildWizardError(accessError);
        }

        const breadcrumb = [
            {
                text: formatText('breadcrumb-personalInformation'),
                url: '/myprofile/edit'
            },
            {
                text: formatText('breadcrumb-selectorRights'),
                url: '/myprofile/rights'
            },
            {
                text: formatText('breadcrumb-rightsAccessView'),
                url: '/myprofile/rights'
            }
        ];

        return (
            <div className="rights-access-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumb}
                                finalTitle={getFinalTitle('breadcrumb-rightsAccessView')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        {wizard}
                    </div>
                </div>
            </div>
        );
    }
}

RightsAccessView.propTypes = {
    history: PropTypes.object.isRequired,
    immRightsProfile: PropTypes.obj,
    rightsActions: PropTypes.obj,
    immAccounts: PropTypes.obj,
    immProfileFields: PropTypes.obj
}

module.exports.constructor = RightsAccessView;

module.exports.RightsAccessView = connect(
    state => ({
        immRightsProfile: state.rightsProfile,
        immAccounts: state.accounts,
        immProfileFields: state.profile,
    }),
    dispatch => ({
        rightsActions: bindActionCreators(rightsActions, dispatch),
    })
)(withRouter(RightsAccessView));
